/**
 *
 * Description 融合审签
 * Author: Qian.qianchen 2019-03-25
 */
'use strict';
angular
    .module('fusionSignModule', [
        'allMediaSignBtnsModule',
        'appSignOperationBtnsModule',
        'newspaperSignOperationBtnsModule',
        'websiteSignOperationBtnsModule',
        'wechatSignOperationBtnsModule',
        'weiboSignOperationBtnsModule',
        'trillSignOperationBtnsModule',
        'baijiahaoSignOperationBtnsModule',
        'qiehaoSignOperationBtnsModule',
        'toutiaoSignOperationBtnsModule',
        'appSignTableModule',
        'editAllMediaSignTableModule',
        'newspaperSignTableModule',
        'websiteSignTableModule',
        'wechatSignTableModule',
        'weiboSignTableModule',
        'trillSignTableModule',
        'baijiahaoSignTableModule',
        'qiehaoSignTableModule',
        'toutiaoSignTableModule',
    ])
    .controller('fusionSignCtrl', [
        '$scope',
        'trsHttpService',
        'modalDialog',
        '$q',
        'localStorageService',
        '$filter',
        'trsspliceString',
        '$window',
        'editingCenterService',
        'iWoService',
        '$rootScope',
        '$interval',
        'forFusionSign',
        '$timeout',
        function (
            $scope,
            trsHttpService,
            modalDialog,
            $q,
            localStorageService,
            $filter,
            trsspliceString,
            $window,
            editingCenterService,
            iWoService,
            $rootScope,
            $interval,
            forFusionSign,
            $timeout
        ) {
            initStatus();
            initData();

            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.status = {
                    isSecond: false, // 是不是二级审核
                    isPending: false,
                    showChannelChoose: false,
                    showMediaType: '', // 默认选中全部渠道

                    OprTime: '',
                    DocType: '',
                    isFirstLevel: true,
                };
                $scope.data = {
                    customConfig: {
                        singleDatePicker: true, // 是否是单选框
                    },
                    orderArray: editingCenterService.getNewspaperOrder(), // 下拉框排序
                    selectedOrder: editingCenterService.getNewspaperOrder()[0],
                    valueForPaper: {}, // 给报纸的下拉框value
                    initDropName: '', // 初始化下拉框的默认名字
                    paperArray: [], // 报纸列表
                    selectedPaper: [], // 选中的
                    channelValue: '', // 选择的产品
                    channelsArray: [], // 下拉框产品数组
                    selectedChannel: [], // 选中的产品
                    selectedBanmian: [], // 选中的版面
                    banmianArray: [
                        {
                            name: '全部版面',
                            value: ''
                        }
                    ], // 版面下拉框数组
                    mediaTypesArray: [],
                    selectedMediaArr: [], // 选择的渠道
                    keywords: '',
                    items: [],
                    selectedArr: [],
                    allMediaType: new Set(),
                    OprTime: getInitTime(),
                };
            }

            /**
             * [initDropDown 获取进入融合界面时的时间戳]
             *
             * @return  {[type]}  [return description]
             */
            function initDropDown() {
                $scope.data.selectedChannel = $scope.data.channelsArray[0];
                $scope.data.selectedBanmian = $scope.data.banmianArray[0];
            }

            /**
             * [getBanmian description]
             *
             * @param   {[type]}  value  [value description]
             *
             * @return  {[type]}         [return description]
             */
            function getBanmian(value) {
                var params = {
                    methodname: 'queryCaiBianBanMians',
                    serviceid: 'mlf_paper',
                    PaperId: value
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    $scope.data.banmianArray = [{
                        name: '全部版面',
                        value: ''
                    }];
                    $scope.data.banmianValue = '';
                    $scope.data.selectedBanmian = $scope.data.banmianArray[0];
                    data.forEach((item) => {
                        item.name = item.CHNLDESC;
                        item.value = item.CHANNELID;
                    });
                    $scope.data.banmianArray = $scope.data.banmianArray.concat(data);
                });
            }

            /**
             * [getInitTime 获取进入融合界面时的时间戳]
             *
             * @return  {[type]}  [return description]
             */
            function getInitTime() {
                return dateFormat('YYYY-mm-dd HH:MM:SS', new Date());
            }

            /**
             * [dateFormat 日期时间格式化]
             *
             * @param   {[type]}  fmt   [fmt description]
             * @param   {[type]}  date  [date description]
             *
             * @return  {[type]}        [return description]
             */
            function dateFormat(fmt, date) {
                let ret;
                const opt = {
                    'Y+': date.getFullYear().toString(), // 年
                    'm+': (date.getMonth() + 1).toString(), // 月
                    'd+': date.getDate().toString(), // 日
                    'H+': date.getHours().toString(), // 时
                    'M+': date.getMinutes().toString(), // 分
                    'S+': date.getSeconds().toString(), // 秒
                    // 有其他格式化字符需求可以继续添加，必须转化成字符串
                };
                for (let k in opt) {
                    ret = new RegExp('(' + k + ')').exec(fmt);
                    if (ret) {
                        fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
                    }
                }
                return fmt;
            }

            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                initMediaTypes();
                requestData();
            }

            /**
             * [initMediaTypes 请求顶部渠道]
             *
             * @return  {[type]}  [return description]
             */
            function initMediaTypes() {
                $scope.loadingPromise = iWoService.getProducts().then((data) => {
                    $scope.data.mediaTypesArray = data;
                    $scope.data.selectedMediaArr.push(data[0]);
                    forFusionSign.getCountAndBindType($scope.data.mediaTypesArray);
                });
            }

            /**
             * [requestData 请求数据]
             *
             * @return  {[type]}  [return description]
             */
            function requestData() {
                var fusionSignShowProduct = JSON.parse(localStorageService.get('fusionSignShowProduct'));
                if (fusionSignShowProduct) {
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        var property =
                            $scope.data.items[i].MEDIATYPE === '5' ||
                                $scope.data.items[i].MEDIATYPE === '17' ||
                                $scope.data.items[i].MEDIATYPE === '17'
                                ? 'ACCOUNTID'
                                : $scope.data.items[i].MEDIATYPE === '4'
                                    ? 'CHANNELID'
                                    : 'SITEID';
                        if ($scope.data.items[i][property] === fusionSignShowProduct.ObjectId) {
                            $scope.data.showProduct = $scope.data.items[i];
                            return;
                        }
                    }
                }
                $scope.data.showProduct = $scope.data.items[0];
            }

            /**
             * [getProductList description] 获取产品列表数据
             * @return {[type]} [description]
             */
            // function getProductList() {
            //     var deffer = $q.defer();
            //     var params = {
            //         serviceid: 'mlf_fusion',
            //         methodname: 'queryDocumentsInShengQianForPC',
            //         PageSize: $scope.page.PAGESIZE,
            //         OprTime: $scope.status.OprTime,
            //         DocType: $scope.status.DocType,
            //         OprTimeStart: angular.isDefined($scope.data.fromdate) ? $scope.data.fromdate : '',
            //         OprTimeEnd: angular.isDefined($scope.data.untildate) ? $scope.data.untildate : '',
            //     };
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
            //         $scope.data.items = [];
            //         data.forEach(function (item, index) {
            //             if (item.DOCCOUNT > 0) {
            //                 $scope.data.items.push(item);
            //                 $scope.data.allMediaType.add(item.MEDIATYPE);
            //             }
            //         });
            //         deffer.resolve();
            //     });
            //     return deffer.promise;
            // }

            /**
             * [fusionAllStatus 融合审签全部审签后定时查询全部审签任务的状态]
             *
             * @param   {[type]}  taskId  [taskId description]
             *
             * @return  {[type]}          [return description]
             */
            $rootScope.fusionAllStatus = function (taskId) {
                const getFusionStatusTapTime = 3000;
                $rootScope.fusionAllStatusTimer = $interval(function () {
                    iWoService.getFusionStatus(taskId).then(function (data) {
                        requestData();
                    });
                }, getFusionStatusTapTime);
            };

            /**
             * [fusionAll 融合全部稿件操作]
             *
             * @param   {[type]}  oprType    [oprType 融合类型-daishen:待审， daibian：待编]
             * @param   {[type]}  actionKey  [actionKey description 操作类型- qianfa: 全部签发， songshen-全部送审， chegao-全部撤稿]
             *
             * @return  {[type]}             [return description]
             */
            $scope.fusionAll = function (oprType, actionKey) {
                let defer = $q.defer();
                let params = {};
                params.mediaTypes = Array.from($scope.data.allMediaType).join(',');
                params.OprTime = $scope.data.OprTime;
                modalDialog.confirmModal('全部签发', '是否要将当前渠道的稿件全部签发？', function () {
                    $scope.loadingPromise = iWoService.fusionAll(oprType, actionKey, params).then(
                        function (data) {
                            defer.resolve(data);
                            $rootScope.fusionAllStatus(data.TASKID);
                        },
                        function (data) {
                        }
                    );
                });

                return defer.promise;
            };

            /**
             * [selectProduct description] 产品选择
             * @param  {[object]} product [description] 产品
             * @return {[type]}         [description]
             */
            $scope.selectProduct = function (product) {
                if ($scope.isSelectedProduct(product)) {
                    $scope.data.showProduct = '';
                    return;
                }
                $scope.data.showProduct = product;
                $scope.page.PAGESIZE = 9;
                $scope.status.OprTime = '';
                localStorageService.set(
                    'fusionSignShowProduct',
                    JSON.stringify({
                        ObjectId:
                            $scope.data.showProduct.MEDIATYPE === '4'
                                ? $scope.data.showProduct.CHANNELID
                                : $scope.data.showProduct.MEDIATYPE === '5' ||
                                    $scope.data.showProduct.MEDIATYPE === '17' ||
                                    $scope.data.showProduct.MEDIATYPE === '19'
                                    ? $scope.data.showProduct.ACCOUNTID
                                    : $scope.data.showProduct.SITEID,
                    })
                );
            };

            /**
             * [isOnlyMine description] 只看通过
             *
             * @param {[type]} key   [key description]
             *
             * @return {[type]}   [return description]
             */
            $scope.isOnlyMine = function(key) {
                $scope.page.CURRPAGE = 1;
                $scope.status[key] = !$scope.status[key];
                $scope.reloadData();
            };

            /**
             * [timeSelect description] 时间筛选
             * @return {[type]} [description]
             */
            $scope.timeSelect = function () {
                $scope.page.CURRPAGE = 1;
                $scope.status.OprTime = '';      
                $scope.reloadData();
            };
            $scope.queryByDropdown = function (type, value) {
                $scope.page.CURRPAGE = 1;               
                if (type === 'paper') {
                    $scope.data.channelValue = value;
                    getBanmian(value);
                    $scope.data.banmianValue = '';
                } else if (type === 'banmian') {
                    $scope.data.banmianValue = value;
                } else if (type === 'media'){
                    $scope.data.channelValue = value;
                }
                $scope.$apply();
                $scope.reloadData();      
            };

            /**
             * [isSelected description] 判断选中的稿件是不是该栏目下
             * @param  {[object]}  product [description] 栏目产品
             * @return {Boolean}         [description]
             */
            $scope.isSelected = function (product) {
                if ($scope.data.selectedArr.length > 0) {
                    var mediaId =
                        $scope.data.selectedArr[0].MEDIATYPE === '5'
                            ? 'PUBLISHACCOUNTIDS'
                            : $scope.data.selectedArr[0].MEDIATYPE === '4'
                                ? 'CHANNELID'
                                : 'SITEID';
                    if (angular.isDefined(product[mediaId]) && $scope.data.selectedArr[0][mediaId] === product[mediaId]) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            };

            /**
             * [examDraftType description]检验稿件类型
             * @param  {[obj]} elm [description]稿件的具体信息
             * @return {[type]}     [description]
             */
            $scope.examDraftType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID !== '1' && elm.DOCTYPEID !== '2';
                }
            };

            /**
             * [refresh description] 表格刷新
             * @param  {[object]} $event [description] 点击事件
             * @return {[type]}         [description]
             */
            $scope.refresh = function ($event) {
                if ($event) {
                    $event.stopPropagation();
                }
                $scope.$broadcast('refresh', true);
            };

            /**
             * [reloadData description]
             *
             * @param   {[type]}  flag  [flag description]
             * @param   {[type]}  true  [true description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.reloadData = function (flag = true) {
                if (flag) {
                    forFusionSign.getCountAndBindType($scope.data.mediaTypesArray);
                }
                $scope.refresh();
            };

            /**
             * [exportDraft description]导出功能
             * @return {[type]} [description]
             */
            $scope.exportDraft = function () {
                var temp = $filter('pick')($scope.data.selectedArr, $scope.examDraftType);
                if (temp.length < 1) {
                    var params = {
                        serviceid: 'mlf_exportword',
                        methodname: 'exportWordFile',
                        MetaDataIds: trsspliceString.spliceString($scope.data.selectedArr, 'METADATAID', ','),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                        function (data) {
                            $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                            $scope.data.selectedArr = [];
                        },
                        function (data) {
                            if (data.REPORTS[0].ISSUCCESS === 'true') {
                                $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                                $scope.data.selectedArr = [];
                            }
                        }
                    );
                } else {
                    modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
                }
            };

            /**
             * [examDraftType description]检验稿件类型
             * @param  {[obj]} elm [description]稿件的具体信息
             * @return {[type]}     [description]
             */
            $scope.examDraftType = function (elm) {
                if (angular.isDefined(elm)) {
                    return elm.DOCTYPEID !== '1' && elm.DOCTYPEID !== '2';
                }
            };

            /**
             * [outSending description]外发功能
             * @return {[type]} [description]
             */
            // $scope.outSending = function () {
            //     var temp = $filter('pick')($scope.data.selectedArr, $scope.examDraftType);
            //     if (temp.length < 1) {
            //         editingCenterService.outSending('', function (result) {
            //             outSendingDraft(result.selectItems);
            //         });
            //     } else {
            //         modalDialog.alertType('只能外发新闻稿或图集稿', '', 'error', false);
            //     }
            // };

            /**
             * [outSendingDraft description]外发函数
             * @param  {[array]} items [description]外发服务的返回值
             * @return {[type]}       [description]
             */
            // function outSendingDraft(items) {
            //     var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            //     var draftids = trsspliceString.spliceString($scope.data.selectedArr, 'METADATAID', ',');
            //     var params = {
            //         serviceid: 'mlf_mailoutgoingOper',
            //         methodname: 'appDaiBianSendEmail',
            //         Emails: userids,
            //         MetaDataIds: draftids,
            //     };
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
            //         function (data) {
            //             modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
            //                 getProductList().then(function () {
            //                     $scope.data.showProduct =
            //                         arrayIndexOfItem($scope.data.items, $scope.data.showProduct) > -1
            //                             ? $scope.data.showProduct
            //                             : $scope.data.items[0];
            //                     localStorageService.set(
            //                         'fusionSignShowProduct',
            //                         JSON.stringify({
            //                             ObjectId:
            //                                 $scope.data.showProduct.MEDIATYPE == '4'
            //                                     ? $scope.data.showProduct.CHANNELID
            //                                     : $scope.data.showProduct.MEDIATYPE == '5'
            //                                         ? $scope.data.showProduct.ACCOUNTID
            //                                         : $scope.data.showProduct.SITEID,
            //                         })
            //                     );
            //                 });
            //             });
            //         },
            //         function () {
            //             $scope.data.selectedArr = [];
            //         }
            //     );
            // }

            /**
             * [isSelectedProduct description] 是否是选中产品
             * @param  {[type]}  product [description] 被选中的产品
             * @return {Boolean}         [description]
             */
            $scope.isSelectedProduct = function (product) {
                if (!$scope.data.showProduct) {
                    return false;
                }
                var id = $scope.data.showProduct.CHANNELID || $scope.data.showProduct.SITEID || $scope.data.showProduct.ACCOUNTID;
                var id_ = product.CHANNELID || product.SITEID || product.ACCOUNTID;
                return $scope.data.showProduct.MEDIATYPE === product.MEDIATYPE && id === id_;
            };
            $scope.mediaChange = function (item) {
                $scope.page.CURRPAGE = 1;
                $scope.data.selectedMediaArr = [];
                $scope.data.selectedMediaArr.push(item);
                // eslint-disable-next-line no-unneeded-ternary
                $scope.status.showChannelChoose = item.MEDIANAME === '全部' ? false : true;
                $scope.status.showMediaType = item.MEDIANAME === '全部' ? '' : item.MEDIATYPE;
                dealChannelName(item);
                if (item.MEDIANAME !== '纸媒') {
                    $scope.data.channelsArray.unshift({
                        name: `请选择${item.MEDIANAME}`,
                        value: ''
                    });
                } else {
                    getBanmian($scope.data.channelsArray[0].value);
                }
                initDropDown();
                // 这两个值是传给组件的(选择的渠道和版面值)
                $scope.data.banmianValue = $scope.data.selectedBanmian.value;
                $scope.data.channelValue = $scope.data.selectedChannel.value;
            };

            /**
             * [dealChannel description] 下拉框筛选数据处理
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function dealChannelName(item) {
                if (!item.SITES) {return;}
                item.SITES.forEach((site) => {
                    site.name = site.SITEDESC || site.CHNLDESC || site.ACCOUNTNAME;
                    site.value = site.CHANNELID || site.SITEID;
                });
                // 先清空原有的
                $scope.data.channelsArray = [];
                $scope.data.channelsArray = $scope.data.channelsArray.concat(item.SITES);
            }

            /**
             * [selectPageNum description]
             *
             * @param   {[type]}  flag  [flag description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.selectPageNum = function (flag) {
                $scope.reloadData(flag);
            };
    
        },
    ]);
